<template>
  <label>{{ translate(`${LOCALE_PREFIX}.form.mealsStation`) }}</label>
  <SelectButtonField
    :id="`isBrandMx`"
    :name="`${formNamespace}isBrandMX`"
    :options="brandMXOptions"
    optionLabel="label"
    optionValue="value"
    :unselectable="false"
    :disabled="isBrandMEQ || isBrandMEQFieldValue || !hasMXTenders || !editMealPlan"
  />
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { storeToRefs } from 'pinia';
import { SitesLocalePrefix } from '../../../../../../enums';
import useTenderType from '../../composables/use-tender-type/use-tender-type';
import { inject } from 'vue';
import { useFieldValue } from 'vee-validate';
import { useFinancialConfigStore } from '@/views/app-modules/sites/src/routes/stores';

const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;

const { brandMXOptions, isBrandMEQ, hasMXTenders } = useTenderType();

const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);

const formNamespace = inject('formNamespace', '');
const isBrandMEQFieldValue = useFieldValue<string>(`${formNamespace}isBrandMEQ`);
</script>
